
export default {
  name: 'SectionStage',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      topZero: true
    }
  },
  computed: {},
  mounted() {
    window.addEventListener('scroll', this.setPositionState)
    this.setPositionState()
  },
  methods: {
    setPositionState() {
      if (process.browser && process.client) {
        this.topZero =
          window.pageYOffset <= 0 &&
          document.querySelectorAll('.header').length > 0
      }
    }
  }
}
